import { dateTimeFormat } from '@/utility/utility_functions'
import Profile from '@/classes/auth/Profile'
import FormData from '@/classes/form/FormData'
import FormDescriptor from '@/classes/form/FormDescriptor'
import { Document } from '@/classes/case/Document'
import User from '@/classes/auth/User'

class Comment {
  constructor (id, contextId, created, modified, content, user, profile, documents) {
    this.id = id
    this.contextId = contextId
    this.created = created
    this.modified = modified
    this.content = content
    this.user = user
    this.profile = profile
    this.documents = documents
    this.formDescriptors = null
    this.formDatas = null
  }

  static asComments (json) {
    return json.map(jsonComment => {
      return Comment.asComment(jsonComment)
    })
  }

  static asComment (json) {
    // TODO: should be removed when the backend returns the correct structure
    json.documents = json.attachments && json.attachments.map((file) => {
      return {
        title: '',
        files: [file]
      }
    })
    return new Comment(
      json.id,
      json.context_id,
      json.created ? dateTimeFormat(json.created) : '',
      json.modified ? dateTimeFormat(json.modified) : '',
      json.content || json.text,
      json.user ? User.asUser(json.user) : {},
      json.profile ? Profile.asProfile(json.profile) : {},
      json.documents ? Document.asDocuments(json.documents) : []
    )
  }

  setFormDescriptors (data) {
    this.formDescriptors = FormDescriptor.asFormDescriptors(data)
  }

  setFormDatas (data) {
    this.formDatas = FormData.initiateFormDatas(this.formDescriptors)
    FormData.loadInitialFormDatas(data, this.formDatas)
    FormDescriptor.checkFormDescriptorsDependencies(this.formDescriptors, this.formDatas)
  }
}

export {
  Comment
}
